const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

let marked = require('marked');

export const helper = app => ({
  checkStatusHistory(historyStatus, pointer, history) {
    switch (historyStatus) {
      case 'PRE_APPROVED':
      case 'INSURANCE_APPROVED':
      case 'INSURANCE_REJECTED':
      case 'APPROVED':
      case 'PAID':
      case 'REJECTED':
      case 'SOFT_REJECT':
      case 'ESTIMATE_COST':
      case 'ON_PROGRESS':
      case 'WAITING_PICKUP':
      case 'RECEIVED_SC':
      case 'DONE':
      case 'REPLACED':
      case 'DONE_REPLACED':
      case 'DONE_REJECTED':
      case 'RESUBMIT_DOCUMENT' && pointer !== 0:
      case 'ACKNOWLEDGE_QOALA':
      case 'PAYMENT_NOT_COMPLETE':
      case 'WAITING_COURIER_START':
      case 'WAITING_COURIER_FINISH':
      case 'WAITING_WALKIN_FINISH':
      case 'WAITING_WALKIN_START':
      case 'COURIER_PICKED_UP':
      case 'INITIATED' && !history[pointer].documents:
        return false;
      default:
        return true;
    }
  },
  currenciesToNumber(x = '') {
    if (x !== 0 && x !== '') return x.replace(/\./g, '');
    return 0;
  },
  currencies(x = '', seperator = '.') {
    const parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, seperator);
    return parts.join(',');
  },
  mapHistoryDescription(claim, status) {
    switch (status) {
      case 'WAITING_COURIER_START':
      case 'WAITING_WALKIN_START':
      case 'ESTIMATE_COST':
      case 'WAITING_COURIER_FINISH':
      case 'WAITING_WALKIN_FINISH':
      case 'PAYMENT_NOT_COMPLETE':
        return `claimdesc_phone_${status}`;
      default:
        return '';
    }
  },
  phoneNumberSend(number) {
    let phone;
    if (number.charAt(0) === '0') {
      phone = `+62${number.replace('0', '')}`;
    } else if (number.slice(0, 3) === '+62') {
      phone = `+62${number.replace('+62', '')}`;
    } else {
      phone = `+62${number}`;
    }
    return phone;
  },
  phoneNumberInput(number) {
    let phone;
    if (number.charAt(0) === '0') {
      phone = number.replace('0', '');
    } else if (number.slice(0, 3) === '+62') {
      phone = number.replace('+62', '');
    } else {
      phone = number;
    }
    return phone;
  },
  getLang() {
    return app.i18n.locale;
  },
  goLogin() {
    app.router.push(app.localePath('account'));
  },
  goRegister() {
    app.router.push(app.localePath('sessions-register'));
  },
  getId(hash) {
    let value = String(hash);
    return value.slice(1, value.length);
  },
  setupWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    const WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
    return true;
  },
  capitalize(s) {
    if (typeof s !== 'string') return '';
    const splitStr = s.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  },
  toSnakeCase(str) {
    const afterSplit = str.toLowerCase().split(' ');
    let newStr = '';
    for (const [idx, val] of afterSplit.entries()) {
      if (idx > 0) {
        newStr += this.capitalize(val);
      } else {
        newStr += val;
      }
    }
    return newStr;
  },
  callUserID() {
    const user = app.store.getters['user/getUserData'];
    if (user) {
      return user.id;
    }
    return 'Guest';
  },
  // isTelesales() {
  //   const user = app.store.getters['user/getUserData'];
  //   console.log('user', user);
  //   if (user.groups && user.groups.length > 0) {
  //     return user.groups.some(role => role === 'qoalaapp::telesale');
  //   }
  //   return false;
  // },
  countryCode(phoneNumber) {
    if (phoneNumber) {
      const rawPhoneData = phoneUtil.parseAndKeepRawInput(phoneNumber);
      const countryCode = phoneUtil.getRegionCodeForNumber(rawPhoneData);
      return countryCode;
    }
    return 'ID';
  },
  formValidation(payload) {
    let empty = [];
    for (let [key, value] of Object.entries(payload)) {
      key.toLowerCase();
      if (key === 'email' && !this.validateEmail(value)) {
        empty.push(key);
        continue;
      }
      if (value === '' || value === null || value === undefined) {
        empty.push(this.toSnakeCase(key));
      }
    }
    return empty;
  },
  validateEmail(email) {
    // eslint-disable-next-line
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },
  translateAirtable(content) {
    const parser = JSON.parse(content);
    return parser;
  },
  markdownContent(content) {
    marked.setOptions({
      renderer: new marked.Renderer(),
      gfm: true,
      tables: true,
      breaks: true,
      pedantic: false,
      smartLists: true,
      smartypants: false
    });
    return marked(content);
  }
});

export default ({ app }, inject) => {
  inject('helper', helper(app));
};
